import { ImpedanceTable } from './ImpedanceTable';
import { SaveLoadControls } from './SaveLoadControls';
import type { ImpedanceDataDto } from '../../types';

interface TableRow {
  frequency: number | '';
  magnitude: number | '';
  phase: number | '';
}

interface SavedData {
  id: string;
  name: string;
  data: ImpedanceDataDto;
  timestamp?: Date;
}

interface ImpedanceDataSectionProps {
  title: string; // e.g., "Baseline" or "Measurement"
  rows: TableRow[];
  onRowsChange: (rows: TableRow[]) => void;
  savedItems: SavedData[];
  currentName: string;
  onNameChange: (name: string) => void;
  onSave: () => void;
  onLoad: (id: string) => void;
  onDelete: (id: string) => void;
}

export function ImpedanceDataSection({
  title,
  rows,
  onRowsChange,
  savedItems,
  currentName,
  onNameChange,
  onSave,
  onLoad,
  onDelete
}: ImpedanceDataSectionProps) {
  return (
    <div className="bg-white dark:bg-gray-800 rounded-lg shadow p-6 border border-gray-200 dark:border-gray-700">
      {/* Section Header */}
      <div className="flex items-center gap-2 mb-6">
        <span className="text-2xl">📊</span>
        <h3 className="text-lg font-semibold text-gray-900 dark:text-white">
          {title} Impedance Data
        </h3>
      </div>

      {/* Table Editor */}
      <div className="mb-6">
        <ImpedanceTable rows={rows} onRowsChange={onRowsChange} title={`${title} Data Points`} />
      </div>

      {/* Save/Load Controls */}
      <SaveLoadControls
        savedItems={savedItems}
        currentName={currentName}
        onNameChange={onNameChange}
        onSave={onSave}
        onLoad={onLoad}
        onDelete={onDelete}
        title={title}
      />
    </div>
  );
}
